<template>
    <div class="user-profile">
        <form @submit.prevent="validateForm">
            <div class="form-group">
                <label>Corporate Account Type</label>
                <div>
                    <b>{{ getCompanyTypeByValue(value.companyType) ? getCompanyTypeByValue(value.companyType).text : '' }}</b>
                </div>
            </div>
            <div class="form-group required">
                <label>Company Name</label>
                <input type="text" name="companyName" data-vv-validate-on="blur" data-vv-as="company name"
                    placeholder="Company Name" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('companyName')
                    }" v-model="value.companyName">
                <div v-show="validationErrors.has('companyName')" class="invalid-feedback">
                    {{ validationErrors.first('companyName') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Company Registration Number</label>
                <input type="text" name="companyRegistrationNumber" data-vv-validate-on="blur"
                    data-vv-as="company registration number" :placeholder="`Enter your company registration number`"
                    v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('companyRegistrationNumber')
                    }" v-model="value.companyRegistrationId">
                <small>Example: 0123456789-X</small>

                <div v-show="validationErrors.has('companyRegistrationNumber')" class="invalid-feedback">
                    {{ validationErrors.first('companyRegistrationNumber') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Company Email Address</label>
                <input type="text" name="email" data-vv-validate-on="blur" data-vv-as="email address"
                    v-validate="'required|email'" placeholder="Company Email Address" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('email')
                    }" v-model="value.emailAddress" readonly>

                <div v-show="validationErrors.has('email')" class="invalid-feedback">
                    {{ validationErrors.first('email') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Contact Person</label>
                <input type="text" name="contactPerson" data-vv-validate-on="blur" data-vv-as="contact person"
                    placeholder="Contact Person" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('contactPerson')
                    }" v-model="value.contactPerson">
                <div v-show="validationErrors.has('contactPerson')" class="invalid-feedback">
                    {{ validationErrors.first('contactPerson') }}
                </div>
            </div>

            <div class="form-group required">
                <label>Contact Person Phone Number</label>
                <input type="text" name="phoneNumber" data-vv-validate-on="blur" data-vv-as="phone number"
                    placeholder="Contact Person Phone Number" v-validate="'required'" :class="{
                    'form-control': true,
                    'is-invalid':  validationErrors.has('phoneNumber')
                }" v-model="value.phoneNumber">
                <div v-show="validationErrors.has('phoneNumber')" class="invalid-feedback">
                    {{ validationErrors.first('phoneNumber') }}
                </div>
            </div>

            <div class="form-group">
                <div class="mt-2 mb-2">
                    <b>Company Address</b>
                </div>
                <div class="form-group required">
                    <label>Address Line 1</label>
                    <input type="text" name="addressLine1" data-vv-as="address line 1" data-vv-validate-on="blur"
                        placeholder="Address Line 1" v-model="value.addressLine1" v-validate="'required'" :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('addressLine1')
                    }">

                    <div v-show="validationErrors.has('addressLine1')" class="invalid-feedback">
                        {{ validationErrors.first('addressLine1') }}
                    </div>
                </div>

                <div class="form-group">
                    <label>Address Line 2</label>
                    <input type="text" class="form-control" placeholder="Address Line 2" v-model="value.addressLine2">
                </div>

                <div class="form-row">
                    <div class="form-group col-lg-6 col-md-6 required">
                        <label>City</label>
                        <input type="text" name="city" data-vv-validate-on="blur" placeholder="City"
                            v-model="value.addressCity" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('city')
                        }">
                        <div v-show="validationErrors.has('city')" class="invalid-feedback">
                            {{ validationErrors.first('city') }}
                        </div>
                    </div>

                    <div class="form-group col-lg-4 col-md-6 required">
                        <label>State</label>
                        <select name="state" data-vv-validate-on="blur" v-model="value.addressState"
                            v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('state')
                        }">
                            <option :value="null">Choose...</option>
                            <option v-for="(state, index) in malaysiaStates" :key="index" :value="state.value">
                                {{state.text}}
                            </option>
                        </select>
                        <div v-show="validationErrors.has('state')" class="invalid-feedback">
                            {{ validationErrors.first('state') }}
                        </div>
                    </div>

                    <div class="form-group col-lg-2 col-md-12 required">
                        <label>Postal Code</label>
                        <input type="text" name="postcode" placeholder="Postal Code" data-vv-validate-on="blur"
                            v-model="value.addressPostcode" v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('postcode')
                        }">
                        <div v-show="validationErrors.has('postcode')" class="invalid-feedback">
                            {{ validationErrors.first('postcode') }}
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { getCompanyTypeByValue } from '@/config/companyTypes';
import malaysiaStates from '@/config/malaysiaStates';
import profileMixins from './profileMixins';
export default {
    'name': 'CompanyProfileComponent',
    'props': {
        'value': Object
    },
    'mixins': [
        profileMixins
    ],
    data () {
        return {
            malaysiaStates
        };
    },
    mounted () {

    },
    'methods': {
        getCompanyTypeByValue,
        validateForm () {
            return this.$validator.validateAll();
        }
    }
};

</script>
